import authLayoutStyles from "layouts/AuthLayout/AuthLayout.styles";
import { Box, Container, Stack, Typography } from "@mui/material";
import title from "global/constants/TitleConstants";
import { useAppSelector } from "hooks/use-app-select";
import { RootState } from "utils/store";
import { authRef, refFont } from "screens/Auth/AuthReferenceStyles";

interface CustomProps {
  children: any;
  maxWidth?: string;
  minWidth?: string;
  IsCustomAuthCardLayout?: boolean;
}

const AuthLayout = (props: CustomProps) => {
  const classes = authLayoutStyles;
  const { loading } = useAppSelector((state: RootState) => state.app);
  return (
    <>
      {props.IsCustomAuthCardLayout ? (
        <Box
          sx={{
            ...classes.root,
            minWidth: props.minWidth ? props.minWidth : "none",
          }}
        >
          <Stack sx={{ ...classes.rootBox, justifyContent: "center" }}>
            <Container
              maxWidth={false}
              sx={{ ...classes.container, maxWidth: props.maxWidth ?? "700px" }}
            >
              <main id="main-content" tabIndex={-1} style={{ outline: "none" }}>
                {props.children}
              </main>
            </Container>
          </Stack>
          <footer>
            <Stack mt={1.5} alignItems="center" mb={2}>
              <Typography
                variant="body2"
                color={
                  props.IsCustomAuthCardLayout ? "common.white" : "text.secondary"
                }
              >{`© ${new Date().getFullYear()} ${
                title.App
              }. All rights reserved.`}</Typography>
            </Stack>
          </footer>
        </Box>
      ) : (
        <Box sx={classes.root}>
          <Box sx={classes.rootBox}>
            <Container
              maxWidth={false}
              sx={{ ...classes.container, maxWidth: props.maxWidth ?? "700px" }}
            >
              <main id="main-content" tabIndex={-1} style={{ outline: "none" }}>
                {props.children}
              </main>
            </Container>
            <footer>
              <Stack mt={1} alignItems="center">
                {/* Matches the legal line on the split-screen auth pages
                 * (Login, Register): same wording, muted and small rather than
                 * body copy in primary text. */}
                <Typography
                  sx={{
                    color: authRef.footerText,
                    fontSize: refFont.cardFooter,
                    lineHeight: 1.6,
                  }}
                >{`© ${new Date().getFullYear()} ${
                  title.App
                }. All rights reserved.`}</Typography>
              </Stack>
            </footer>
          </Box>
        </Box>
      )}
    </>
  );
};

export default AuthLayout;
